/**
 * Trunnion AI - Favorites Bar
 * Horizontal scrollable row of pinned items on the dashboard.
 */

import { Link } from 'react-router-dom';
import { Star, GitBranch, Bot, Play } from 'lucide-react';
import { useFavorites } from '@/hooks/useFavorites';
import { ROUTES } from '@/config/routes';

const iconMap: Record<string, typeof Star> = {
  workflow: GitBranch,
  agent: Bot,
  execution: Play,
};

function getRoute(type: string, id: string): string {
  switch (type) {
    case 'workflow':
      return ROUTES.WORKFLOW_EDIT(id);
    case 'agent':
      return ROUTES.AGENT_DETAIL(id);
    case 'execution':
      return ROUTES.EXECUTION_DETAIL(id);
    default:
      return ROUTES.DASHBOARD;
  }
}

export function FavoritesBar() {
  const { favorites } = useFavorites();

  if (favorites.length === 0) return null;

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1">
      <Star className="h-4 w-4 shrink-0 text-trunnion-gold-500" />
      {favorites.map((fav) => {
        const Icon = iconMap[fav.type] ?? Star;
        return (
          <Link
            key={`${fav.type}-${fav.id}`}
            to={getRoute(fav.type, fav.id)}
            className="flex shrink-0 items-center gap-1.5 rounded-lg border border-trunnion-slate-700 bg-trunnion-slate-800 px-3 py-1.5 text-xs font-medium text-trunnion-slate-300 hover:border-trunnion-gold-500/50 hover:text-trunnion-gold-500 transition-colors"
          >
            <Icon className="h-3.5 w-3.5" />
            <span className="max-w-30 truncate">{fav.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
